import { Outlet } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { TicketFlowPage, TicketingSetupOverview, ticketingSetupLoader } from "./TicketingSetupPage";

export const ticketingSetupRouter = {
  path: "/ticketing-setup",
  id: "ticketing-setup",
  element: <Outlet />,
  handle: {
    crumb: () => <Breadcrumb name="Ticketing Setup" href="/ticketing-setup" />,
  },
  children: [
    {
      index: true,
      id: "ticketing-setup-overview",
      element: <TicketingSetupOverview />,
      loader: ticketingSetupLoader,
    },
    {
      path: "ticket/:ticketId/:step",
      id: "ticketing-setup-ticket-step",
      element: <TicketFlowPage />,
      loader: ticketingSetupLoader,
    },
  ],
};
